// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"d24cf80d","917":"9b890994"}[chunkId] + ".chunk.js";
};